import { EmoticonWinkIcon } from './EmoticonWinkIcon';

/**
 * author: Michael Irigoyen
 * id 652D2244-1764-4B42-B04D-157DDD9DC464
 * name emoticon-wink
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-wink.svg
 * tags
 * - Emoji 
 */
export const SmileyWinkIcon = EmoticonWinkIcon;
export default SmileyWinkIcon